module.exports = __webpack_public_path__ + "img/logo-app.d9a985e9.svg";